export default __webpack_public_path__ + "static/media/O-138.fdae397b.png";